import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

import { DataTable, DataTableHead, DataTableRow } from '@flixbus/honeycomb-react';

import PageSizer from 'common/PageSizer';

import AddMembersToGroupModal from './components/AddMembersModal';
import DeleteGroupConfirmationModal from './components/DeleteConfirmationModal';
import GroupControls from './components/GroupControls';
import ManageGroupDataModal from './components/ManageGroupDataModal';
import CreateNewGroupBtn from './components/NewGroupBtn';
import NoGroups from './components/NoGroups';
import SingleGroupTab from './components/SingleGroupTab';
import TableLoader from './components/TableLoader';
import { groupsStore } from './GroupsStore';

import styles from './styles.module.css';

const Profile = observer(() => {
	const { groupsMapped, isLoading, isNoGroups } = groupsStore;

	useEffect(() => {
		groupsStore.fetchGroups();
	}, []);

	return (
		<PageSizer>
			{!groupsStore.isGroupSelected && (
				<>
					<h1>Profile settings</h1>
					<h2>Group management</h2>
					{isNoGroups && !isLoading && <NoGroups />}
					{!isNoGroups && (
						<div className={styles.btnWrap}>
							<CreateNewGroupBtn />
						</div>
					)}
					{isLoading && <TableLoader />}{' '}
					{!isLoading && !isNoGroups && (
						<DataTable
							headers={
								<DataTableHead>
									<th style={{ width: '20%' }} scope="col">
										Group Name
									</th>
									<th scope="col">Members</th>
									<th scope="col">Description</th>
									<th scope="col">Created by</th>
									<th scope="col" />
								</DataTableHead>
							}
						>
							{[...groupsMapped.values()].map(
								({ name, description, membersCount, createdBy, id }) => (
									<DataTableRow onClick={() => groupsStore.selectGroup(id)} key={name}>
										<td>{name}</td>
										<td style={{ textAlign: 'center' }}>{membersCount}</td>
										<td>{description}</td>
										<td>{createdBy}</td>
										<td>
											<GroupControls groupId={id} />
										</td>
									</DataTableRow>
								)
							)}
						</DataTable>
					)}
				</>
			)}
			{groupsStore.isGroupSelected && <SingleGroupTab />}
			<ManageGroupDataModal />
			<AddMembersToGroupModal />
			<DeleteGroupConfirmationModal />
		</PageSizer>
	);
});

export default Profile;
